import { Injectable } from '@angular/core';
import { SEARCH_ORIGIN } from '@app/enums/search-origin.enum';

/**
 * CI-22535: Servicio ligero para rastrear el origen de búsqueda usado
 * durante el Trip Lookup. El componente que inicia la búsqueda establece
 * el origen (setOrigin) y ApiService lo consume (consumeOrigin) al emitir
 * el evento GET_RESERVATION en New Relic.
 */
@Injectable({
  providedIn: 'root',
})
export class SearchOriginService {
  private _currentOrigin: SEARCH_ORIGIN | null = null;

  /**
   * Establece el origen de búsqueda actual antes de disparar la llamada de lookup.
   */
  setOrigin(origin: SEARCH_ORIGIN): void {
    this._currentOrigin = origin;
  }

  /**
   * Devuelve el origen actual y lo resetea para evitar que valores obsoletos
   * se envíen en eventos posteriores.
   */
  consumeOrigin(): SEARCH_ORIGIN | null {
    const origin = this._currentOrigin;
    this._currentOrigin = null;
    return origin;
  }

  /**
   * Devuelve el origen actual sin consumirlo (lectura no destructiva).
   */
  getOrigin(): SEARCH_ORIGIN | null {
    return this._currentOrigin;
  }

  /**
   * Resetea el origen. Útil al limpiar sesión o navegar a home.
   */
  reset(): void {
    this._currentOrigin = null;
  }
}
